export const Permission = {
  data: () => ({}),
  methods: {
    ShowPermisos ({ permisos, tableMain }) {
      if (permisos.descripcion.special === 'all-access') {
        tableMain.header.options.map(action => {
          action.hidden = ''
        })
        tableMain.body.actions.map(action => {
          action.hidden = ''
        })
        return
      }

      tableMain.header.options.map(action => {
        permisos.permisos.map(item => {
          if (action.code !== 'libre') {
            if (action.code === item.slug) {
              action.hidden = ''
            }
          }
        })
      })

      tableMain.body.actions.map(action => {
        permisos.permisos.map(item => {
          if (action.code !== 'libre') {
            if (action.code === item.slug) {
              action.hidden = ''
            }
          }
        })
      })
    }
  }
}
